<template>
  <div class="page-main">

    <!-- NAVBAR (sans hero) -->
    <LandingNavbar />

    <main class="container py-6">

      <!-- TITRE -->
      <div class="row mb-5 text-center">
        <h1 class="fw-bold">Nous contacter</h1>
        <p class="text-muted">
          Pour toute information, partenariat ou demande spécifique,
          n’hésitez pas à contacter la CNTIPPEE.
        </p>
      </div>

      <!-- INFOS + FORMULAIRE -->
      <div class="row g-4 mb-6">

        <!-- INFOS -->
        <div class="col-lg-5">
          <div class="card h-100">
            <div class="card-body">

              <h4 class="fw-semibold mb-4">Coordonnées</h4>

              <p>
                <i class="fe fe-map-pin me-2 text-primary"></i>
                Haut de Gué-Gué, 117 Impasse André MBA OBAME<br>
                BP 22, Libreville
              </p>

              <p>
                <i class="fe fe-phone me-2 text-primary"></i>
                +241 11 73 19 63
              </p>

              <p>
                <i class="fe fe-mail me-2 text-primary"></i>
                contact@cntippee-gabon.org
              </p>

              <p>
                <i class="fe fe-globe me-2 text-primary"></i>
                www.cntippee-gabon.org
              </p>

            </div>
          </div>
        </div>

        <!-- FORMULAIRE -->
        <div class="col-lg-7">
          <div class="card h-100">
            <div class="card-body">

              <h4 class="fw-semibold mb-4">Envoyer un message</h4>

              <form @submit.prevent="submitForm">

                <div class="mb-3">
                  <label class="form-label">Nom complet</label>
                  <input type="text" class="form-control" v-model="form.name" required>
                </div>

                <div class="mb-3">
                  <label class="form-label">Email</label>
                  <input type="email" class="form-control" v-model="form.email" required>
                </div>

                <div class="mb-3">
                  <label class="form-label">Sujet</label>
                  <input type="text" class="form-control" v-model="form.subject">
                </div>

                <div class="mb-4">
                  <label class="form-label">Message</label>
                  <textarea class="form-control" rows="5" v-model="form.message" required></textarea>
                </div>

                <button class="btn btn-primary-gradient">
                  <i class="fe fe-send me-2"></i>
                  Envoyer
                </button>

              </form>

            </div>
          </div>
        </div>

      </div>

      <!-- CARTE GOOGLE MAPS -->
      <div class="row">
        <div class="col-12">
          <div class="card overflow-hidden">
            <iframe
                src="https://www.google.com/maps?q=Haut%20de%20Gu%C3%A9-Gu%C3%A9%20Libreville&output=embed"
                width="100%"
                height="400"
                style="border:0;"
                allowfullscreen
                loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>

    </main>

  </div>
</template>

<script>
  import LandingNavbar from "../../../components/landing/LandingNavbar.vue";

  export default {
    name: "ContactPage",
    components: {
      LandingNavbar
    },
    data() {
      return {
        form: {
          name: "",
          email: "",
          subject: "",
          message: ""
        }
      };
    },
    methods: {
      submitForm() {
        // 🔜 à brancher plus tard sur l’API
        console.log("Formulaire envoyé :", this.form);
        alert("Votre message a bien été envoyé !");
        this.form = { name: "", email: "", subject: "", message: "" };
      }
    }
  };
</script>
